import { render, staticRenderFns } from "./SeckillProduct.vue?vue&type=template&id=1aa665d1&scoped=true"
import script from "./SeckillProduct.vue?vue&type=script&lang=js"
export * from "./SeckillProduct.vue?vue&type=script&lang=js"
import style0 from "./SeckillProduct.vue?vue&type=style&index=0&id=1aa665d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa665d1",
  null
  
)

component.options.__file = "SeckillProduct.vue"
export default component.exports